class FeaturedBrands extends HTMLElement {
  constructor() {
    super()

    this.carousel = this.querySelector('swiper-container')
  }

  connectedCallback() {
    this.addCarouselParameters()
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      mousewheel: {
        enabled: true,
        forceToAxis:true,
      },
      freemode: true,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      roundedLengths: true,
      pagination: {
        clickable: true,
        el: '.featured-brands__carousel-dots--mobile'
      },
      breakpoints: {
        520: {
          slidesPerView: 2.2,
        },
        767: {
          slidesPerView: 2.67
        },
        991: {
          slidesPerView: 1.67,
          pagination: {
            clickable: true,
            el: '.featured-brands__carousel-dots--desktop'
          },
        },
        1120: {
          slidesPerView: 2.2,
          slidesOffsetAfter: 8,
          slidesOffsetBefore: 0,
          spaceBetween: 8,
          pagination: {
            clickable: true,
            el: '.featured-brands__carousel-dots--desktop'
          },
        },
        1600: {
          slidesPerView: 3.2,
        }
      },
      on: {
        init() {
        }
      }
    });
    
    this.carousel.initialize();
  }
}

if (!customElements.get('featured-brands'))
  customElements.define('featured-brands', FeaturedBrands)